import React, { Component } from 'react';
import _ from 'lodash';
import Loading from 'src/components/Loading';
import Button from 'jbc-front/components/Button';
import { Task, PdfFile } from 'jbc-front/components/icons';
import PdfCreateModalContainer from '../containers/PdfCreateModalContainer';
import PdfDownloadModalContainer from '../containers/PdfDownloadModalContainer';
import styles from './PdfModalBase.scss';

export default class PdfModalBase extends Component {
  constructor(props) {
    super(props);

    this.state = { modalOpen: false };
  }

  componentDidMount() {
    const { fetchPdfJobStatus } = this.props;
    fetchPdfJobStatus();
  }

  openModal = () => {
    this.setState({ ...this.state, modalOpen: true });
  };
  closeModal = () => {
    this.setState({ ...this.state, modalOpen: false });
  };

  isFileCreating = () => _.includes(['waiting', 'running'], _.get(this.props.pdfJob, 'status'));
  isFileCreated = () => _.get(this.props.pdfJob, 'status') === 'success';

  render() {
    const PayReportModal = () => {
      if (this.isFileCreated()) {
        return (
          <PdfDownloadModalContainer
            isOpen={this.state.modalOpen}
            hideModal={this.closeModal}
            revisionYear={this.props.revisionYear}
          />
        );
      }
      return (
        <PdfCreateModalContainer
          isOpen={this.state.modalOpen}
          hideModal={this.closeModal}
          revisionYear={this.props.revisionYear}
        />
      );
    };

    if (this.isFileCreating()) {
      return (
        <div className={styles.loading}>
          <Button primary widthWide disabled icon={<Loading />}>
            データ作成中
          </Button>
        </div>
      );
    }

    if (!this.props.isFetchCompleted) {
      return (
        <div className={styles.loading}>
          <Button primary widthWide disabled icon={<Loading />} />
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className={styles.button}>
          <Button
            onClick={this.openModal}
            primary
            widthWide
            disabled={this.props.isAllConfirmedAlert ? '' : 'disabled'}
            icon={this.isFileCreated() ? <PdfFile size={22} /> : <Task />}
          >
            {this.isFileCreated() ? 'PDF一括出力' : 'PDF一括作成'}
          </Button>
        </div>
        <PayReportModal />
      </React.Fragment>
    );
  }
}
